/**
 * RD avatar — 40×40 circle with initials and a stable per-RD color
 * derived from a simple hash of the name.
 */

const AVATAR_COLORS = [
  { bg: "#E8927C", text: "#FFFFFF" }, // coral/salmon
  { bg: "#8B9A6B", text: "#FFFFFF" }, // olive/sage
  { bg: "#D4A843", text: "#FFFFFF" }, // warm yellow
  { bg: "#6B9A7B", text: "#FFFFFF" }, // sage green
  { bg: "#7C92C8", text: "#FFFFFF" }, // muted blue
  { bg: "#C87CA0", text: "#FFFFFF" }, // dusty rose
  { bg: "#A07CC8", text: "#FFFFFF" }, // muted purple
  { bg: "#C89A7C", text: "#FFFFFF" }, // warm tan
];

function hashName(name: string): number {
  let hash = 0;

  for (let i = 0; i < name.length; i++) {
    hash = (hash << 5) - hash + name.charCodeAt(i);
    hash |= 0;
  }

  return Math.abs(hash);
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);

  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  return name.slice(0, 2).toUpperCase();
}

// Under the always theme the avatar is lime with olive initials (D3). The
// colors above are inline styles, so the theme's classes are important.
const THEMED =
  "brand:bg-(--color-avatar)! brand:text-(color:--color-avatar-foreground)! brand:font-sans brand:font-bold";

const SIZE_CLASSES: Record<40 | 48, string> = {
  40: "h-10 w-10 text-sm",
  48: "h-12 w-12 text-base",
};

export function RDAvatar({ name, size = 40 }: { name: string; size?: 40 | 48 }) {
  const color = AVATAR_COLORS[hashName(name) % AVATAR_COLORS.length];
  const initials = getInitials(name);

  return (
    <div
      className={`${SIZE_CLASSES[size]} shrink-0 rounded-full flex items-center justify-center font-semibold ${THEMED}`}
      style={{ backgroundColor: color.bg, color: color.text }}
    >
      {initials}
    </div>
  );
}
